import React, { useState, useEffect } from 'react';
import { t } from '../../utils/i18n';

const LiveMonitoringPage = ({ api }) => {
  const [liveData, setLiveData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [autoRefresh, setAutoRefresh] = useState(true);
  const [lastUpdate, setLastUpdate] = useState(new Date());

  useEffect(() => {
    fetchLiveData();

    if (autoRefresh) {
      const interval = setInterval(() => {
        fetchLiveData();
      }, 30000);

      return () => clearInterval(interval);
    }
  }, [autoRefresh]);

  const fetchLiveData = async () => {
    setLoading(true);
    try {
      const today = new Date().toISOString().split('T')[0];
      const response = await api.get(`/attendance_summaries?date=${today}`);
      setLiveData(response.attendance_summaries || []);
      setLastUpdate(new Date());
    } catch (error) {
      console.error('Failed to fetch live data:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatTime = (timestamp) => {
    if (!timestamp) return '-';
    return new Date(timestamp).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  };

  const stats = {
    checkedIn: liveData.filter(d => d.first_check_in).length,
    notCheckedIn: liveData.filter(d => !d.first_check_in).length,
    checkedOut: liveData.filter(d => d.last_check_out).length,
    late: liveData.filter(d => d.late_minutes > 0).length
  };

  return (
    <div className="contentArea">
      <div className="dFlex baseTableHd mb_24">
        <h1 className="txt28 fwBold colorBlack">Live Attendance Monitoring</h1>
        <div className="dFlex" style={{ gap: '12px', alignItems: 'center' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input
              type="checkbox"
              checked={autoRefresh}
              onChange={(e) => setAutoRefresh(e.target.checked)}
            />
            Auto Refresh
          </label>
          <button className="btnAdd me-3" onClick={fetchLiveData}>
            <img src="/images/refresh.png" alt="" style={{ width: '16px', marginRight: '8px' }} />
            Refresh Now
          </button>
        </div>
      </div>

      <div style={{ marginBottom: '16px', color: '#6c757d', fontSize: '14px' }}>
        Last updated: {lastUpdate.toLocaleTimeString()}
      </div>

      <div className="dFlex" style={{ gap: '16px', marginBottom: '24px' }}>
        <div className="dashFeaturesBox" style={{ flex: 1, borderLeft: '4px solid #28a745' }}>
          <div className="dashFeaturesTxt">
            Checked In
            <span className="txt30 fwBold" style={{ color: '#28a745' }}>{stats.checkedIn}</span>
          </div>
        </div>
        <div className="dashFeaturesBox" style={{ flex: 1, borderLeft: '4px solid #dc3545' }}>
          <div className="dashFeaturesTxt">
            Not Checked In
            <span className="txt30 fwBold" style={{ color: '#dc3545' }}>{stats.notCheckedIn}</span>
          </div>
        </div>
        <div className="dashFeaturesBox" style={{ flex: 1, borderLeft: '4px solid #17a2b8' }}>
          <div className="dashFeaturesTxt">
            Checked Out
            <span className="txt30 fwBold" style={{ color: '#17a2b8' }}>{stats.checkedOut}</span>
          </div>
        </div>
        <div className="dashFeaturesBox" style={{ flex: 1, borderLeft: '4px solid #ffc107' }}>
          <div className="dashFeaturesTxt">
            Late Arrivals
            <span className="txt30 fwBold" style={{ color: '#ffc107' }}>{stats.late}</span>
          </div>
        </div>
      </div>

      <div className="baseTableWrap">
        <div className="baseTableContainer">
          {loading ? (
            <div style={{ textAlign: 'center', padding: '40px' }}>Loading...</div>
          ) : (
            <table className="baseTable">
              <thead>
                <tr>
                  <th>Personnel ID</th>
                  <th>Check In</th>
                  <th>Check Out</th>
                  <th>Status</th>
                  <th>Late (mins)</th>
                </tr>
              </thead>
              <tbody>
                {liveData.length === 0 ? (
                  <tr>
                    <td colSpan="5" style={{ textAlign: 'center', padding: '40px' }}>
                      No live data available
                    </td>
                  </tr>
                ) : (
                  liveData.map((record) => (
                    <tr key={record.id}>
                      <td>{record.army_personnel_id}</td>
                      <td>
                        <span style={{ color: record.first_check_in ? '#28a745' : '#dc3545' }}>
                          {formatTime(record.first_check_in)}
                        </span>
                      </td>
                      <td>
                        <span style={{ color: record.last_check_out ? '#17a2b8' : '#6c757d' }}>
                          {formatTime(record.last_check_out)}
                        </span>
                      </td>
                      <td>
                        <span className={`status ${record.status === 'present' ? 'green' : 'red'}`}>
                          {record.status || 'absent'}
                        </span>
                      </td>
                      <td>
                        <span style={{ color: record.late_minutes > 0 ? '#dc3545' : '#28a745' }}>
                          {record.late_minutes || 0}
                        </span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default LiveMonitoringPage;
